import { createGlobalStyle } from './index';
import fonts from './fonts';

// TODO: use variables from mui theme

export default createGlobalStyle`
  ${fonts}

  h1 {
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.334;
    letter-spacing: 0rem;
  }

  h2, h3, h4, h5, h6 {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0.0075em;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
    overflow: visible;
    text-transform: none;
  }

  a {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  #root {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .fixed-footer-content {
    flex: 1 1 auto;
    flex-grow: 1;
  }

  .section {
    margin-top: 48px;
  }

  /* Disable body scrolling when modals are open. The position: fixed; stuff is to
  make it work on iOS. */
  .ReactModal__Body--open, .disable-body-scroll {
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .disabled {
    opacity: 0.3;
  }
`;
